<template>
    <customModal :containersm="true" @closeModal="closeModal">

        <template #title>
            {{ isEditMode ? 'Update Milestone' : 'Create Milestone' }}
        </template>

        <template #body>
            <div class="row">

                <!-- Milestone Name -->
                <div class="col-md-12 form-group mb-2">
                    <label class="mb-0">
                        Milestone Name <sup><i class="fa fa-asterisk required"></i></sup>
                    </label>

                    <input v-model="milestone.milestoneName" @input="clearError" class="form-control" type="text" />

                    <span v-if="errors.name" class="errormsg ml-0">
                        {{ errorMessages.name }}
                    </span>
                </div>

            </div>

            <!-- Active -->
            <div class="form-group mb-2">
                <label>
                    <input type="checkbox" v-model="milestone.active" class="mr-1" />
                    Active
                </label>
            </div>

            <div class="text-right">
                <button class="save_btn py-1 px-3" @click="submitMilestone">
                    {{ isEditMode ? 'Update' : 'Create' }}
                </button>
            </div>

        </template>
    </customModal>
</template>

<script src="./MilestoneModal.js"></script>